import React from 'react'
import { Box } from '@mui/material'
import { OrgInvitationStatus } from 'pure-js/types/OrgInvitation'

import { INTERAX_COLORS } from '../../../constants/colors'
import { useTranslation } from '../../../shared/hooks/useIntractionTranslate'
import { orgInviteStatusTranslationKey } from '../orgTranslationKeys'

type Tone = { bg: string; fg: string; border: string }

const TONES: Record<OrgInvitationStatus, Tone> = {
  [OrgInvitationStatus.PENDING]: {
    bg: INTERAX_COLORS.sun20,
    fg: INTERAX_COLORS.sun,
    border: INTERAX_COLORS.sun40
  },
  [OrgInvitationStatus.ACCEPTED]: {
    bg: 'rgba(74, 222, 128, 0.15)',
    fg: INTERAX_COLORS.green,
    border: 'rgba(74, 222, 128, 0.35)'
  },
  [OrgInvitationStatus.EXPIRED]: {
    bg: INTERAX_COLORS.white10,
    fg: INTERAX_COLORS.white70,
    border: INTERAX_COLORS.white10
  },
  [OrgInvitationStatus.REVOKED]: {
    bg: 'rgba(248, 113, 113, 0.12)',
    fg: INTERAX_COLORS.redError,
    border: 'rgba(248, 113, 113, 0.3)'
  }
}

export const OrgInviteStatusChip: React.FC<{ status: OrgInvitationStatus }> = ({ status }) => {
  const { t } = useTranslation()
  const tone = TONES[status]

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 1.25,
        py: 0.5,
        borderRadius: 999,
        backgroundColor: tone.bg,
        color: tone.fg,
        border: `1px solid ${tone.border}`,
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0.3,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        lineHeight: 1.4
      }}
    >
      {t(orgInviteStatusTranslationKey(status))}
    </Box>
  )
}
